import { createListenerMiddleware } from '@reduxjs/toolkit';

import { appInit } from 'FRONTEND/actions/app';
import { consultationRead } from 'FRONTEND/reducers/consultationSlice';
import { initWorkflowsState, readWorkflow } from 'FRONTEND/reducers/workflowSlice';
import { selectConsultationWorkflowId, selectConsultationWorkflowVersion } from 'FRONTEND/selectors/consultationSelectors';
import { LOCAL_STORAGE_LAST_WORKFLOW_KEY, LOCAL_STORAGE_WORKFLOW_CACHE_VERSION_KEY, WORKFLOW_CACHE_NUMBER } from 'FRONTEND/utils/constants';
import { getNonSerializableItem, saveNonSerializableItem } from 'FRONTEND/utils/nonSerializableStorage';

const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  // When the web page is loaded
  actionCreator: appInit,
  // Get the current workflow from local storage, if any
  effect: async(action, { dispatch }) => {
    const storedVersion = localStorage.getItem(LOCAL_STORAGE_WORKFLOW_CACHE_VERSION_KEY);
    if (storedVersion !== String(WORKFLOW_CACHE_NUMBER)) {
      // Cache is stale — wipe it and record the current number
      localStorage.removeItem(LOCAL_STORAGE_LAST_WORKFLOW_KEY);
      localStorage.setItem(LOCAL_STORAGE_WORKFLOW_CACHE_VERSION_KEY, String(WORKFLOW_CACHE_NUMBER));
      return;
    }

    const storedWorkflow = localStorage.getItem(LOCAL_STORAGE_LAST_WORKFLOW_KEY);
    if (storedWorkflow) {
      const storageId = saveNonSerializableItem(JSON.parse(storedWorkflow));
      dispatch(initWorkflowsState({ storageId }));
    }
  },
});

listenerMiddleware.startListening({
  // When we open a consultation
  actionCreator: consultationRead.fulfilled,
  // Fetch the corresponding workflow
  effect: async(action, { getState, dispatch }) => {
    const workflowId = selectConsultationWorkflowId(getState());
    const workflowVersion = selectConsultationWorkflowVersion(getState());
    // Smart thunk that will only fetch the workflow if it's not already in memory
    dispatch(readWorkflow({ id: workflowId, version: workflowVersion }));
  },
});

listenerMiddleware.startListening({
  // When the current workflow changes
  predicate: (action, currentState, originalState) => (
    currentState.workflows.storageId !== originalState.workflows.storageId
  ),
  // Store it in the local storage
  effect: async(action, { getState }) => {
    const currentWorkflow = getNonSerializableItem(getState().workflows.storageId);
    if (currentWorkflow) {
      localStorage.setItem(LOCAL_STORAGE_LAST_WORKFLOW_KEY, JSON.stringify(currentWorkflow));
    }
  },
});

export default listenerMiddleware.middleware;
